import Swiper from 'swiper';
import { refs, domReady } from '../modules/utils.js';
import { test as testMedia } from '../modules/match-media.js';

class LstyleSlider extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
    this.#slider();
  }

  #listeners() {
    this.refs.prev?.addEventListener('click', () => {
      if (this.slider) {
        this.slider.slidePrev();
      }
    });

    this.refs.next?.addEventListener('click', () => {
      if (this.slider) {
        this.slider.slideNext();
      }
    });
  }

  #slider() {
    if (!this.refs.slider) return;
    const slidesCount = this.refs.slides?.length ?? 0;
    const isMobile = testMedia('small');
    if (slidesCount < 1) return;

    if (!isMobile && this.refs.slides.length < 3) {
      this.refs.nav.style.display = 'none';
    }

    let slidesPerView = 3;
    if (this.dataset.cards) {
      slidesPerView = parseInt(this.dataset.cards);
    }
    if (isMobile) {
      slidesPerView = 1;
    }

    this.slider = new Swiper(
      this.refs.slider,
      {
        slidesPerView,
        spaceBetween: 26,
        loop: false,
        loopAdditionalSlides: 1
      }
    );

    // this.slider.on('slideChange', () => {
    //   this.dataset.index = this.slider.realIndex;
    // });
  }
}

customElements.define('lstyle-slider', LstyleSlider);
